export default {
  data() {
    return {
      headers: [
        { text: 'Тип', align: 'left', value: 'type' },
        { text: 'Дата создания', align: 'right', value: 'created_at' },
        { text: 'Сумма', align: 'right', value: 'amount' },
        { text: 'Кошелек', align: 'right', value: 'project_name' },
        { text: 'Название', align: 'right', value: 'title' },
      ],
      rowsPerPageItems: [
        50, 100, 250, { text: 'Весь список', value: -1 },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    transactions() {
      const { userTransactions } = this.$store.state;
      return userTransactions.map(item => ({
        type: item.type,
        created_at: item.created_at,
        amount: item.amount,
        project_name: item.project_name,
        title: item.title,
      }));
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    getTypeLabel(type) {
      return type === 'in'
        ? { label: 'Входящая', color: 'green' }
        : { label: 'Исходящая', color: 'red' };
    },
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetTransactions');
  },
};
